import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import '../../assets/css/modal.css'



function ConfirmationModal(props) {
  

  const [deactivReason, setdeactivReason] = useState("")
  const [toastMsg, settoastMsg] = useState("none");
  //SL-699 Seller Stock
  const [inputStockValue, setInputStockValue] = useState('');
  const [stockError, setStockError] = useState(false); 
  const [stockErrorMsg, setStockErrorMsg] = useState('');

  //SL-699
  const styles = {
    container: {
      stock: {
        marginTop: "20px",
        marginBottom: "-20px"
      }
    },
    text: {
      currentStock: {
        position: "absolute",
        top: "-7px",
        left: props.from === "productDetail" ? "175px" : "95px",
        background: "white",
        padding: "0px 5px",
        fontSize: "11px"
      },
      stockErrorMsg: {
        position: "relative",
        background: "white",
        padding: "0px 5px",
        fontSize: "12px",
        color:"red",
        
      }
    },
    input: {
      stock: {
        padding: "9px 22px 2px 11px",
        width: "150px"
      }
    }
  }

  /**
   * SL - 699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if(/^\d*$/.test(stockValue)) {
      setStockError(false);
      setStockErrorMsg('');
      setInputStockValue(stockValue);
    }
      
  };

  /**
   * Validate the Stock Input Field
   * @returns 
   */
  const validateStockValue = () => {

     // Validation: Ensure the input is a positive number or zero
     if(!inputStockValue || inputStockValue == '' || inputStockValue == null || inputStockValue == undefined){
      setStockError(true);
      setStockErrorMsg("Please enter a valid number.");
      return false;
    }
    else if(isNaN(inputStockValue)) {
      setStockError(true);
      setStockErrorMsg("Please enter a valid number.");
      return false;
    }
    else if(Number(inputStockValue) <= 0) {
      setStockError(true);
      setStockErrorMsg("Please enter a valid positive number.");
      return false;
    }
    else{
      setStockError(false);
      setStockErrorMsg('');
      return true;
    }
        
  }

  /**
   * Handle the Confirmation Dialog Submit
   */
  function handleConfirmationSubmit(){
    if(validateStockValue()){
      setInputStockValue(Number(inputStockValue));
      props.responseconfirmationFun("yes", props.selectedId,Number(inputStockValue), "home-enquiry", props?.combination, props?.prSts)
    }
      
  }

  function reasonInacFun(ans, id) {
    settoastMsg("none")
    if (deactivReason === undefined || deactivReason === "" || deactivReason === null) {
      settoastMsg("block")
    }
    else {
      props.responseconfirmationFun(ans, id, null,deactivReason)
      settoastMsg("none")
    }
  }

  
  


  return (
    <>
      <div className="">
        {props.from === "negotiate" ? <></> :
          <Modal.Header onClick={() => props.onHide(false)} className="close-design Confirmation-Modal-H fs-12" closeButton>

            {props.pId}
            <Modal.Title></Modal.Title>
          </Modal.Header>}

        <Modal.Body>
          {props.proresDeact === true ?
            <>
              <label for="reasonbox-title">Reason -</label>
              <br></br>
              <textarea id='reasonbox' placeholder='Please tell us why you are deactivating this product?' rows={4} onChange={(e) => setdeactivReason(e.target.value)} />
            </>
            : <></>}
          <p className='reasonbox-title'>
            {props.msg}
          </p>
          {/*SL-699 Stock Popup Start */}
          {( (props.from === "enquiry" && props.enquiryTo == "approve") || props.from === "productDetail" || props.from == "opportunity") && (props.proresDeact === false || props.proresDeact == undefined) && <div className="row" style={styles.container.stock}>
                      <div className="col-12">
                        <span style={styles.text.currentStock}>Current Stock</span>
                        <input 
                          type="number" 
                          value={inputStockValue}
                            onChange={(e) => {
                               handleStockChange(e.target.value);
                              
                          }}
                          style={styles.input.stock} 
                          onWheel={(e) => e.target.blur()} 
                        />
                      
                      </div>
                      <div className='col-12'>
                      {stockError && <span style={styles.text.stockErrorMsg}>{stockErrorMsg}</span>}
                      </div>
          </div>}
          {/*SL-699 Stock Popup End */}
        </Modal.Body>
        <Modal.Footer>
          <div class="text-center detail-new bottom-action">
            <div className='text-center action-button'>
              {props.proresDeact === true ?
                <><span className="toastAlert" style={{ "display": toastMsg }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter the reason</span>

                  <button className={!props?.buttonDesign ? 'yes-button' : "no-button"} onClick={() => reasonInacFun("yes", props.selectedId)}>Yes</button></>
                :
                (props.from === "enquiry" && props.enquiryTo == "approve") ? 
                  <button className={!props?.buttonDesign ? 'yes-button' : "no-button"} onClick={() => handleConfirmationSubmit("yes", props.selectedId,inputStockValue, "home-enquiry", props?.combination, props?.prSts)}>Submit</button>
                  : 
                    props.from === "productDetail" || props.from === "opportunity"? 
                     <button className={!props?.buttonDesign ? 'yes-button' : "no-button"} onClick={() => handleConfirmationSubmit("yes", props.selectedId,inputStockValue, "home-enquiry", props?.combination, props?.prSts)}>Yes</button>
                    :
                     <button className={!props?.buttonDesign ? 'yes-button' : "no-button"} onClick={() => props.responseconfirmationFun("yes", props.selectedId, "home-enquiry", props?.combination, props?.prSts)}>Yes</button>

              }
              { (props.from !== "enquiry" || props.enquiryTo == "disapprove") &&
                <button className={props?.buttonDesign ? 'yes-button' : "no-button"} onClick={() => props.onHide(false)}>No</button>
              }
            </div>
          </div>
        </Modal.Footer>
      </div>
    </>

  )
}
export default ConfirmationModal;